import { IconButton, Tooltip } from "@mui/material"
import { red } from "@mui/material/colors"
import Iconify from "minimals-template/components/Iconify"
import { useDialog } from "lib/@hooks/useDialog"
import { ErrorDetailsDialog } from "./error-details-dialog"
import { BlockClicks } from "lib/@components/block-clicks"

export function GroupFailedIcon({ group }) {
    const errorDetailsDialog = useDialog(<ErrorDetailsDialog group={group} />, { maxWidth: "lg", fullWidth: true })

    return (
        <Tooltip title="Open error details">
            <BlockClicks>
                <IconButton
                    data-cy="group-failure-icon"
                    aria-label="open-error-details"
                    sx={{ color: red[600] }}
                    onClick={openErrorDetails}
                >
                    <Iconify icon={"jam:alert-f"} />
                </IconButton>
            </BlockClicks>
        </Tooltip>
    )

    async function openErrorDetails() {
        await errorDetailsDialog()
    }
}
